'use strict';

function menuSticky() {
  // set header height for avoit jumping
  // 68 is top height before sticky
  var headerHeightFull = $('.banner-leaderboard-large').height() + $('.megamenu').height() + 68;
  var isAlready = false;

  $('header').css('height', headerHeightFull);

  // for styling sticky top
  function addStickyClass() {
    if ($(window).scrollTop() >= 10) {
      $('body').addClass('stick-menu');

      if ($('.pseudo-menu').length && !isAlready) {
        // 50 is header top height after scroll
        var fromTop = $('.banner-leaderboard-large').height() + $('.megamenu').height() + 50;

        $('.pseudo-menu').css('top', fromTop);
        isAlready = true;
      }
    } else {
      $('body').removeClass('stick-menu');
    }
  }

  $(window).on('scroll', addStickyClass);
  addStickyClass();
}

function menuHover() {
  var setOtherDefault = null;
  $('.nav > .dropdown:not(.active-menu-item)').on('mouseover', function (e) {
    var $this = $(this);

    if (!$this.hasClass('hovered')) {
      $this.addClass('hovered');
      // open and disable hole menu prevent hovering next item
      $this.parent().addClass('disable-all');

      // remove other opened items by click
      $('.nav > .dropdown').removeClass('open');
    }
  });

  $(document).on('mouseover', function (e) {
    var container = $('.nav > .dropdown.hovered');

    // if the target out of our selected
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      setOtherDefault = setTimeout(function () {
        container.parent().removeClass('disable-all');
        container.removeClass('hovered');
      }, 300);
    } else {
      // still on our target
      clearTimeout(setOtherDefault);
    }
  });
}

// todo: maybe do it in backend
function spaceForStaticSubMenu() {
  if ($('.be-open').length) {
    $('header').css('margin-bottom', $('.be-open').height());
  }
}

spaceForStaticSubMenu();
menuSticky();
menuHover();


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/menu.js
// module id = 955
// module chunks = 0